/* eslint-disable */
const messages = {
  'about.title': 'Tiäđuh palvâlusâst - Varaamo',
  'app.about': 'Tiäđuh',
  'app.login': 'Čáládât siisâ',
  'app.logout': 'Čáládât olgos',
  'app.my_reservations': 'Muu väärridmeh',
  'app.search': 'Uuccâm',
  'home.title': 'Ovdâsijđo - Varaamo',
  'home.what_purpose': 'Maid tun halijdah porgâđ?',
  'imagepanel.images': 'Koveh',
  'login.back': 'Maasâd',
  'login.login': 'Čáládât siisâ',
  'login.login_and_save': 'Čáládât siisâ já vuorkkii',
  'login.password': 'Syelinummeer',
  'login.modal_title': 'Čáládât siisâ',
  'login.username': 'Kirjerájukoortâ nummeer',
  'multiday.begin': 'Álgá',
  'multiday.cancel': 'Keesi maasâd',
  'multiday.end': 'Nohá',
  'multiday.header': 'Väärrid maaŋgâ piäiván',
  'myreservations.no_ordinary': 'Iä táváliih väärridmeh čäittimnáál.',
  'myreservations.no_preliminary': 'Iä algâväärridmeh čäittimnáál.',
  'myreservations.ordinary_reservations': 'Táváliih väärridmeh',
  'myreservations.page_header': 'Muu väärridmeh',
  'myreservations.preliminary_reservations': 'Algâväärridmeh',
  'myreservations.title': 'Muu väärridmeh - Varaamo',
  'notfound.title': '404 Sijđo ij kavnuu - Varaamo',
  'ResourceAvailability.available': 'Tállân finnimnáál',
  'ResourceAvailability.availableAt': 'Finnimnáál tme {time}',
  'ResourceAvailability.closed': 'Kiddâ',
  'ResourceAvailability.reserved': 'Väridum ubâ peeivi',
  'reservation.accept': 'Tuhhit',
  'reservation.all': 'Puoh',
  'reservation.cancel': 'Keesi maasâd',
  'reservation.edit': 'Mute',
  'reservation.information': 'Tiäđuh',
  'reservation.reject': 'Hilgo',
  'reservation.reservation_status': 'Väridem tile',
  'reservation_calendar.back': 'Maasâd',
  'reservation_calendar.choose_time': 'Valjii, mon ááigán halijdah väridiđ.',
  'reservation_calendar.confirm_changes': 'Visásmit nubástusâid',
  'reservation_calendar.go_to_selected': 'Moonâ väljejum čuosâttâhân',
  'reservation_calendar.reserve': 'Väärrid',
  'reservation_calendar.reserving': 'Väriduvvoo...',
  'reservation_calendar.saving': 'Vyerkkejuvvoo...',
  'reservation_calendar.today': 'Onne',
  'reservation_cancel.are_you_sure': `Lah-uv vises et halijdah keessiđ maasâd {num, plural,
      one {čuávuváá väridem}
      other {čuávuváid väärridmijd}
      }:`,
  'reservation_cancel.back': 'Maasâd',
  'reservation_cancel.by_contact': 'Taam väridem kalga keessiđ maasâd västideijee virgeulmuu peht. Jis tun halijdah keessiđ väridem maasâd tâi mutteđ väridemääigi, te vääldi ohtâvuođâ virgeulmui, kote västid saajeest.',
  'reservation_cancel.cancel': 'Keesi väridem maasâd',
  'reservation_cancel.canceling': 'Kiässoo maasâd...',
  'reservation_cancel.do_not_cancel': 'Ele keesi väridem maasâd',
  'reservation_cancel.titleConfirm': 'Naanood maasâd keessim',
  'reservation_cancel.titlePreliminary': 'Väridem maasâd keessim',
  'reservation_form.address': 'Čujottâs',
  'reservation_form.address_city': 'Kaavpug',
  'reservation_form.address_street': 'Kátučujottâs',
  'reservation_form.address_zip': 'Postânummeer',
  'reservation_form.back': 'Maasâd',
  'reservation_form.billing_address': 'Rekigistemčujottâs',
  'reservation_form.comments': 'Kommenteh',
  'reservation_form.comments_help': 'Väärridmân kyeskee máhđuliih lasetiäđuh',
  'reservation_form.enter_valid_email': 'Addel tohálii šleđgâpostâčujottâs',
  'reservation_form.event_description': 'Lasetiäđuh',
  'reservation_form.field_max_length': 'Kiedi maksimikukkodâh lii {maxLength} merkkâd.',
  'reservation_form.must_accept_terms': 'Tun koolgah tuhhiittiđ saje lattimnjuolgâdusâid, vâi puávtáččih väridiđ saje',
  'reservation_form.number_of_participants': 'Uásálistei meeri',
  'reservation_form.read_terms': 'Mun lam luuhâm já tuhhiittâm lattimnjuolgâdusâid',
  'reservation_form.required_field': 'Págulâš tiätu',
  'reservation_form.reserver_email': 'Šleđgâpostâ',
  'reservation_form.reserver_id': 'Y-tubdâldâh / persovntubdâldâh',
  'reservation_form.reserver_name': 'Värideijee / Laiguutteijee',
  'reservation_form.reserver_phone_number': 'Puhelin',
  'reservation_form.save': 'Vuorkkii',
  'reservation_form.saving': 'Vyerkkejuvvoo...',
  'reservation_form.staff_event': 'Virgáduv jieijâs tábáhtus',
  'reservation_form.staff_event_help': 'Virgáduv jieijâs tábáhtus tuhhiittuvvoo automatlávt já áinooh páguliih tiäđuh láá värideijee nommâ já lasetiäđuh.',

  'reservation_info.address': 'Čujottâs:',
  'reservation_info.back': 'Maasâd',
  'reservation_info.billing_address': 'Rekigistemčujottâs:',
  'reservation_info.comments': 'Kommenteh:',
  'reservation_info.comments_help': 'Väärridmân kyeskee máhđuliih lasetiäđuh',
  'reservation_info.event_description': 'Lasetiäđuh:',
  'reservation_info.help_title': 'Ravvuuh väridem várás',
  'reservation_info.login_required': 'Tun ferttiih čáládâttâđ siisâ, vâi puávtáččih väridiđ saje.',
  'reservation_info.max_period': `Väridem maksimikukkodâh:{days, plural,
            =0 {} one {\u00a0# peivi} other {\u00a0# peeivi}}{hours, plural,
            =0 {} one {\u00a0# tijme} other {\u00a0# tiijme}}{minutes, plural,
            =0 {} one {\u00a0# miinut} other {\u00a0# miinut}}.`,
  'reservation_info.max_per_user': 'Väärridmij maksimimeeri oovtâ kevttei: {amount}',
  'reservation_info.number_of_participants': 'Uásálistei meeri:',
  'reservation_info.reservable_after_days': 'Saje kalga väridiđ ucemustáá {days} {days, plural, one {peeivi} other {peeivi}} muuneeld.',
  'reservation_info.reservation_time': 'Väridemäigi',
  'reservation_info.reservation_info': 'Väridem tiäđuh',
  'reservation_info.reserver_email': 'Šleđgâpostâ:',
  'reservation_info.reserver_id': 'Y-tubdâldâh / Persovnnummeer:',
  'reservation_info.reserver_name': 'Värideijee / Laiguutteijee:',
  'reservation_info.reserver_phone_number': 'Puhelin:',
  'reservation_info.resource': 'Viste:',
  'reservation_info.save': 'Vuorkkii',
  'reservation_info.saving': 'Vyerkkejuvvoo...',
  'reservation_list.no_reservations': 'Tust iä lah vala väärridmeh.',
  'reservation_modal.confirm_help': `Lah-uv vises, et halijdah {num, plural,
      one {väridiđ saje ááigán}
      other {väridiđ soojijd ááigán}      }:`,
  'reservation_modal.editing_after': 'Nubástusâi maŋa:',
  'reservation_modal.editing_are_you_sure': 'Lah-uv vises et halijdah mutteđ jieijâd väridemtiäđuid?',
  'reservation_modal.editing_before': 'Ovdil nubástusâid:',
  'reservation_modal.preliminary_form_help': 'Teevdi vala čuávuváid tiäđuid algâväridem várás. Tasnijn (*) merkkejum tiäđuh láá páguliih',
  'reservation_modal.preliminary_help': `Tun lah algâlávt väärridmin {num, plural, 
      one {ááigán}
      other {aigijd}
      }:`,
  'reservation_modal.title_confirm': 'Väridem nanodem',
  'reservation_modal.title_editing': 'Nubástusâi nanodem',
  'reservation_modal.title_preliminary': 'Algâväridem',
  'reservation_page.reservation_status_title': 'Väridem tile',
  'reservation_page.reserve_title': 'Väärrid',
  'reservation_page.resource_info': 'Lasetiäđuh',
  'reservation_page.title': '{resourceName} - väridemkalender - Varaamo',
  'reservation_success.info_email': 'Täärhib tiäđuh algâväärridmist vuolgâttuvvojeh väridem ohtâvuođâst adelum šleđgâpostâčujottâsân',
  'reservation_success.made_preliminary': `Tun lah algâlávt väridâm saje {name}
      {times, plural, one {ááigán} other {aigijd} }:`,
  'reservation_success.sent': 'Tuu väridempiivdâ lii vuolgâttum',
  'resource.image_alt': 'Kove {resourceName} -saajeest',
  'resource.reservation_status': 'Väridem tile',
  'resource.reserve': 'Väärrid',
  'resource.title': '{resourceName} - Varaamo',
  'search.help_text': 'Uusâ saje čälimáin uuccâmkiädán tiäđuid, moh lohtâseh sajan.',
  'search.no_results': 'Ohtâgin uuccâmpuáđus ij kavnum.',
  'search.page_header': 'Uuccâm',
  'search.title': 'Uuccâm - Varaamo',
  'search_controls.go_to_selected': 'Moonâ väljejum čuosâttâhân',
  'search_controls.search': 'Uusâ',
  'search_controls.today': 'Onne',
  'search_filters.purpose': 'Riäiduh, saje tâi palvâlus',
  'search_filters.unit': 'Kirjerááju',
  'search_result.details': 'Lasetiäđuh',
  'search_result.hours_available': `{hours, plural,
      one {# tijme}
      other {# tiijme}
      } available`,
  'search_result.reserve': '. Väärrid.',
  'timerange.timestring': 'tme {begin} - {end}',
  'timeslot.editing': 'Muttemnáál',
  'timeslot.free': 'Rijjâ',
  'timeslot.login_to_reserve': 'Čáládât siisâ, vâi puávtáččih väridiđ taam saje.',
  'timeslot.not_reservable': 'Ij lah väridemnáál',
  'timeslot.reserved': 'Väridum',
  'timeslots.comments': 'Kommenteh',
  'timeslots.functions': 'Tooimah',
  'timeslots.not_reservable_today': 'Iä väridemnáál ääigih väljejum peeivi.',
  'timeslots.reserver': 'Värideijee',
  'timeslots.status': 'Väridem tile',
  'timeslots.time': 'Äigi',
};

export default messages;



/** WEBPACK FOOTER **
 ** ./app/messages/smn.js
 **/